import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AssignTestComp from "./Component/AssignTestComp"


const AssignTest =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AssignTestComp />
        </div>
        <Footer />
        </>
    )
}

export default AssignTest